<template>
  <div class="botao-seletor-ncm-container">
    <button
      v-for="(item, index) in botoesBusca"
      :key="index"
      @click="trocaTipo(item)"
      :class="['botao-seletor-ncm', { 'botao-seletor-ncm-selecionado': tipo == item }]"
    >
      {{ item }}
    </button>
  </div>
</template>

<script>
export default {
  name: "BotaoBusca",
  props: {
    trocaTipo: Function,
    botoesBusca: Array,
    tipo: String
  }
};
</script>

<style lang="scss" scoped>
.botao-seletor-ncm-container {
  display: flex;
  align-items: center;
}
.botao-seletor-ncm {
  margin-right: 5px;
  padding: 0 10px;
  border: 1px solid var(--cinza1);
  color: var(--azul4);
  background: var(--branco);
  border-radius: 50px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 66px;
  height: 30px;
  box-shadow: 2px 2px 4px var(--sombra2);
  transition: height 0.2s ease-out;
  input {
    cursor: pointer;
    height: 14px;
    width: 14px;
    margin-left: 5px;
  }
  &:hover {
    transition: background 0.3s ease-in-out;
    text-decoration: none;
    background: var(--cinza02);
  }
}
.botao-seletor-ncm-selecionado {
  border: 1px solid var(--azul4);
  background: var(--azul4);
  color: var(--branco);
  height: 35px;
  transition: height 0.2s linear;
  &:hover {
    transition: height 0.2s linear;
    text-decoration: none;
    background: var(--azul4);
  }
}
</style>
